import { SharingButtons } from "lib-core"

export default SharingButtons
